export const SET_HEADER_TEXT = 'SET_HEADER_TEXT'
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'
export const CHANGE_LOCATE_SUCCESS = 'CHANGE_LOCATE_SUCCESS'



